<script>
  import FormValidate from "./FormValidate.svelte";
  import StripeField from "./StripeField.svelte";
  import { createEventDispatcher } from "svelte";
 
  const dispatch = createEventDispatcher();

  export let data;
  export let person;
  export let noclose;

  $: onboardPaymentLink = data.onboardPaymentLinks.filter((obj) => obj.link === person.id)[0];

  let errorList = [];
  let formValidateList = [];
  let isSuccess = false;
  let stripeField;
  let name;
  let phoneNumber;
  let address;
  let email;

  const close = () => {
    dispatch("close");
  };

  const pay = () => {
    for(let i in formValidateList)
      try {
        formValidateList[i].validate();
      }
      catch (ex) {
        console.log(ex);
      }
    if (errorList.length == 0) {      
      stripeField.submit();
    }
  };

  const toFixed = (num) =>{
    return parseFloat(num).toFixed(2);
  }

  const success = () =>{
    isSuccess = true;
  }
</script>

<div class="chatwith-box">
  <div style="padding-top: 20px" class=""> 
    {#if !noclose}
    <div class="close-modal" on:click={close}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fas"
        data-icon="times"
        class="svg-inline--fa fa-times fa-w-11"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 352 512"
        ><path
          fill="black"
          d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
        /></svg
      >
    </div>
      {#if onboardPaymentLink.image}
      <div class="chatwith-image">
        <img alt="imageFile" src={onboardPaymentLink.image} />
      </div>    
      {/if}  
      {#if onboardPaymentLink.name}
      <div class="chatwith-title">{onboardPaymentLink.name}</div>
      {/if}  
    {/if}    
    {#if onboardPaymentLink.Description}
    <div class="chatwith-description">{@html onboardPaymentLink.Description}</div>
    {/if}  
    <div class="chatwith-price">{toFixed(onboardPaymentLink.price)} {onboardPaymentLink.currency}</div>
    
    {#if onboardPaymentLink.requireName == true}
      <div class="chatwith-form-element">
        <input bind:value={name} type="text" placeholder="Name" />
      </div>    
      <FormValidate bind:value={errorList} bind:this={formValidateList[0]} item = {{"type":"text","val":name,"telNum":"", "required":true}}  {data} index={0}/>
    {/if}    
    {#if onboardPaymentLink.requirePhoneNumber == true}
      <div class="chatwith-form-element">
        <input bind:value={phoneNumber} type="text" placeholder="Phone number" />
      </div>   
      <FormValidate bind:value={errorList} bind:this={formValidateList[1]} item = {{"type":"tel","val":phoneNumber,"telNum":phoneNumber, "required":true}}  {data} index={1}/>
    {/if}  
    {#if onboardPaymentLink.requireAddress == true}
      <div class="chatwith-form-element">
        <input bind:value={address} type="text" placeholder="Address" />
      </div>  
      <FormValidate bind:value={errorList} bind:this={formValidateList[2]} item = {{"type":"text","val":address,"telNum":"", "required":true}}  {data} index={2}/>
    {/if}  
    {#if onboardPaymentLink.requireEmail == true}
      <div class="chatwith-form-element">
        <input bind:value={email} type="email" placeholder="Email" />
      </div>    
      <FormValidate bind:value={errorList} bind:this={formValidateList[3]} item = {{"type":"email","val":email,"telNum":"", "required":true}}  {data} index={3}/>
    {/if}  
    <div class="chatwith-form-element">
      <StripeField {onboardPaymentLink} bgcolor={data.color} bind:this={stripeField} on:success={success} {name}{email}{phoneNumber}{address}/>
    </div>
 
    <div>
      {#if !isSuccess}
      <button
        style="color:{data.textColor};background: {data.color}; border-color: {data.color};"  
        on:click={() => pay()}
        type="button">
        Pay { toFixed(onboardPaymentLink.price)} {onboardPaymentLink.currency} - Stripe</button
      >
      {/if}
    </div>
    {#if onboardPaymentLink.payLink}
    <div class="chatwith-paypal-element">      
      <a
        style="color:{data.textColor};background: #0C59AC; border-color: #0C59AC;text-decoration:none;"  
        href={onboardPaymentLink.payLink}
        target="_blank">
        Pay { toFixed(onboardPaymentLink.price)} {onboardPaymentLink.currency} - Paypal
      </a>
    </div>
    {/if}    
  </div>
</div>

<style>  
  .chatwith-image img{
    width: 80px;
    height: 80px;
    display: block;
    border-radius: 100px;
    border: 1px solid #ccc;
    margin: 0 auto;
    padding:10px;
  }

  .chatwith-box .chatwith-title {
    font-weight: bold;
    padding-bottom: 5px;
    font-size: 24px;
    margin-top: 10px;
    width: 90%
  }

  .chatwith-box .chatwith-price {
    font-weight: bold;
    padding-bottom: 5px;
    font-size: 18px;
  }
  .chatwith-box input {
    display: block;
    padding: 8px 0;
    font-size: 16px;
  }

  .chatwith-box input,
  .chatwith-box button,
  .chatwith-box a {
    border: 1px solid #ccc;
    padding: 5px 5px;
    width: 100%;
    box-sizing: border-box;
    border-radius: 5px;
    font-size: 14px;
    line-height: 1;
    height: auto;
  }

  .chatwith-box .chatwith-form-element {
    margin-top: 10px;
    margin-bottom: 5px;
  }

  .chatwith-box .chatwith-paypal-element {
    margin-top: 10px;
  }
  .chatwith-box .chatwith-paypal-element a{
    display: block;
    text-align: center;
  }

  .chatwith-box button,
  .chatwith-box a {
    border: 1px solid green;
    background: green;
    color: white;
    padding: 10px;
    cursor: pointer;
  }

  .chatwith-box {
    padding: 10px;
    box-sizing: border-box;
    background: white;
    color: #5c5b5b;
    width: 100%;
  }
  
  .close-modal {
    position: absolute;
    right: 0;
    z-index: 1000000;
    top: 0;
    padding: 4px 10px 0 10px;
    color: #fff;
    border-top-right-radius: 1em;
    border-bottom-left-radius: 1em;
    cursor: pointer;
  }

  .close-modal svg {
    width: 0.7em;
  }

  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: #5c5b5b;
  }
  .chatwith-box ::-moz-placeholder {
    /* Firefox 19+ */
    color: #5c5b5b;
  }
  .chatwith-box :-ms-input-placeholder {
    /* IE 10+ */
    color: #5c5b5b;
  }
  .chatwith-box :-moz-placeholder {
    /* Firefox 18- */
    color: #5c5b5b;
  }

  .chatwith-box input[type="text"],
  .chatwith-box input[type="email"] {
    color: #5c5b5b;
    height: 45px;
    margin-bottom: 0;
    font-weight: 0;
    font-weight: normal;
    font-family: Arial;
    font-size: 16px;
  }

</style>
